import { call, put, takeLatest } from "redux-saga/effects";
import { CommonAPI } from "../../../api/commonAPI";
import {
  GET_REVENUE_BY_YEAR_REQUEST,
  GET_REVENUE_BY_YEAR_SUCCESS,
  GET_REVENUE_BY_YEAR_ERROR
} from "../../actions";

function* workerRevenueByYear(action: {
  type: string;
  payload: any;
  meta?: { period?: string };
}): Generator<any> {
  try {
    const response: any = yield call(
      CommonAPI.getRevenueByYear,
      action.payload
    );
    // Filter only all_time_income and unique_reservations_* keys
    let filtered: Record<string, any> = {};
    const fullData = response?.data || {};
    // Determine period key
    let period =
      action?.meta?.period ||
      (action.payload && action.payload.param) || "summary";
    yield put({
      type: GET_REVENUE_BY_YEAR_SUCCESS,
      payload: { [period]: fullData },
    });
  } catch (error) {
    yield put({ type: GET_REVENUE_BY_YEAR_ERROR, payload: error });
  }
}

export function* watcherRevenueByYear() {
  yield takeLatest(GET_REVENUE_BY_YEAR_REQUEST, workerRevenueByYear);
}
